/****************************************************
 * Module Name:  Bid.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import { AppBar, Box, Tab, Tabs, Typography } from "@mui/material";
import React from "react";
import NoPermission from "../../common/noPermission";
import SwipeableViews from "react-swipeable-views";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import SalesBid from "./salesBid";
import ManufacturingBid from "./manufacturingBid";
import Constants from "../../../utility/constants";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ pt: 1 }}>
                    <Typography component={"span"}>{children}</Typography>
                </Box>
            )}
        </Box>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        "aria-controls": `full-width-tabpanel-${index}`,
        value: index,
    };
}

const Bid = () => {
    const theme = useTheme();
    const [value, setValue] = React.useState(
        Constants.USER_PERMISSION.find(
            (iPermission) =>
                iPermission.permissionid === Constants.PERMISSIONS.TENDER_OPERATION_SALES_BID
        ) !== undefined
            ? 0
            : Constants.USER_PERMISSION.find(
                (iPermission) =>
                    iPermission.permissionid ===
                    Constants.PERMISSIONS.TENDER_OPERATION_MANUFACTURING_BID
            ) !== undefined
                ? 1 : 2);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };

    return (
        value === 2 ? <NoPermission /> :
            <Box sx={{
                bgcolor: "background.paper",
                width: "100%",
                padding: "10px",
                position: "relative"
            }}>
                <AppBar position="static" sx={{ bgcolor: "#03a9f4", height: 50 }}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        indicatorColor="secondary"
                        textColor="inherit"
                        variant="fullWidth"
                        aria-label="full width tabs example"
                        sx={{
                            "& .MuiButtonBase-root .MuiTab-root": {
                                color: "#212121",
                                fontWeight: "bold",
                                textAlign: 'center',
                                minHeight: "50px",
                            },
                            "& .MuiTab-root": {
                                paddingBottom: "12px"
                            },
                            "& .Mui-selected": {
                                bgcolor: "#0277bd !important",
                                color: "#fafafa !important",
                                fontWeight: "bold !important",
                                minHeight: "50px",
                            }
                        }}
                        TabIndicatorProps={{ style: { background: "#0277bd" } }}
                    >

                        {/* Sale */}
                        {Constants.USER_PERMISSION.find(
                            (iPermission) =>
                                iPermission.permissionid ===
                                Constants.PERMISSIONS.TENDER_OPERATION_SALES_BID
                        ) !== undefined ? (
                            <Tab
                                // icon={<TbCalendarDollar size={18} />}
                                iconPosition="start"
                                label="Sale"
                                {...a11yProps(0)}
                            />
                        ) : null}


                        {/* Manufacturing */}

                        {Constants.USER_PERMISSION.find(
                            (iPermission) =>
                                iPermission.permissionid ===
                                Constants.PERMISSIONS.TENDER_OPERATION_MANUFACTURING_BID
                        ) !== undefined ? (
                            <Tab
                                // icon={<UploadFileIcon size={18} />}
                                iconPosition="start"
                                label="Manufacturing"
                                {...a11yProps(1)}
                            />
                        ) : null}
                    </Tabs>
                </AppBar>
                <SwipeableViews
                    axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                    index={value}
                    onChangeIndex={handleChangeIndex}
                >
                    {/* Sales */}

                    {Constants.USER_PERMISSION.find(
                        (iPermission) =>
                            iPermission.permissionid ===
                            Constants.PERMISSIONS.TENDER_OPERATION_SALES_BID
                    ) !== undefined ? (
                        <TabPanel value={value} index={0}>
                            <SalesBid />
                        </TabPanel>
                    ) : null}
                    {/* Manufacturing */}

                    {Constants.USER_PERMISSION.find(
                        (iPermission) =>
                            iPermission.permissionid ===
                            Constants.PERMISSIONS.TENDER_OPERATION_MANUFACTURING_BID
                    ) !== undefined ? (
                        <TabPanel value={value} index={1}>
                            <ManufacturingBid />
                        </TabPanel>

                    ) : null}
                </SwipeableViews>

            </Box>
    )
}

export default Bid;